import Button from "@/components/base/Button";
import { mapActions } from "vuex";

export default {
	components: {
		Button,
	},
	data() {
		return {
			currentIndex: 0,
			directionName: "",
		};
	},
	computed: {
		maxIndex() {
			return this.slides.length - 1;
		},
		isLastSlide() {
			return this.currentIndex === this.maxIndex;
		},
		currentSlideArray() {
			return [this.slides[this.currentIndex]];
		},
		transitionDirection() {
			return `h-slide-directional-${this.directionName}`;
		},
	},
	methods: {
		...mapActions({
			deactivateModal: "global/modal/deactivate",
		}),
		next() {
			this.directionName = "right";
			if (!this.isLastSlide) {
				this.currentIndex += 1;
			}

			this.$store.dispatch("sound/fx/play", { id: "whoosh_generic" });
		},
		previous() {
			this.directionName = "left";
			if (this.currentIndex !== 0) {
				this.currentIndex -= 1;
			}

			this.$store.dispatch("sound/fx/play", { id: "whoosh_generic" });
		},
	},
};
